<template>
  <div id="cnotice">
    <section>
      <div class="container my-5">
        <div class="row justify-content-center">
          <div class="col-lg-12 mt-4">
            <h3 v-if="param === 'E'">이 벤 트</h3>
            <h3 v-else>공 지 사 항</h3>

            <!-- 내용 -->
            <div class="row no-cont">
              <p>총 {{ getCurrencyFormat(noticeList.length) }}건</p>
              <table class="table">
                <thead>
                  <tr>
                    <th class="nCategoryTop desktop-only">구분</th>
                    <th class="nTitleTop">제목</th>
                    <th class="nRegDate desktop-only">등록일</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(notice, j) in pagedNoticeList" :key="notice.noticeCode">
                    <td class="col-2 nCategory desktop-only">
                      <span v-if="notice.ctCd === 'NT'"><b style="color:#333">공 &nbsp;&nbsp;지</b></span>
                      <span v-else-if="notice.ctCd === 'EV'"><b style="color:darkgreen">이 &nbsp;벤 &nbsp;트</b></span>
                      <span v-else-if="notice.ctCd === 'TR'"><b style="color:darkred">여행관련</b></span>
                      <span v-else-if="notice.ctCd === 'MO'"><b style="color:darkblue">항공선박</b></span>
                      <span v-else-if="notice.ctCd === 'PR'"><b style="color:darkorange">홍보/안내</b></span>
                      <!-- <span v-else><b style="color:darkslategrey">기 &nbsp;&nbsp;타</b></span> -->
                    </td>
                    <td style="text-align: left; padding-left: 1rem;" class="col-7 nTitle">
                      <div class="nTitleRow">
                        <span class="nCategory-mobile">
                          <span v-if="notice.ctCd === 'NT'"><b style="color:#333">공지</b></span>
                          <span v-else-if="notice.ctCd === 'EV'"><b style="color:darkgreen">이벤트</b></span>
                          <span v-else-if="notice.ctCd === 'TR'"><b style="color:darkred">여행</b></span>
                          <span v-else-if="notice.ctCd === 'MO'"><b style="color:darkblue">항공선박</b></span>
                          <span v-else-if="notice.ctCd === 'PR'"><b style="color:darkorange">홍보안내</b></span>
                        </span>
                        <span class="nContentTitle">
                          <a href="javascript:void(0)" @click="showArea(j)" style="font-weight: 600; color: #333;">
                          {{ notice.nTitle }}
                        </a>
                        </span>
                        <span class="nRegDate-mobile">
                          ({{ getDateFormat(notice.insDate) }})
                        </span>
                      </div>
                      <!-- 공지사항내용 & 바로가기 -->
                      <div class="nContent" :id="'notice-' + j" :name="notice.noticeCode" v-show="openedIndex === j">
                        <div class="containerContent">
                          <!-- 에디터문서렌더링 -->
                          <div class="row mt-1">
                            <hr style="width: 100%;">
                            <div class="markdown-body ql-editor" v-html="renderedHtml"></div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="col-3 nRegDate desktop-only">
                      {{ getDateFormat(notice.insDate) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- pagenation area -->
            <nav aria-label="Page navigation">
              <ul class="pagination justify-content-center">
                <li class="page-item">
                  <a class="page-link" aria-label="Previous" @click="paging('p')">
                    <i class="bi bi-chevron-bar-left"></i>
                  </a>
                </li>
                <li class="page-item" v-for="j in cntPage" :key="j">
                  <a class="page-link" @click="paging(j)">{{ j }}</a>
                </li>
                <li class="page-item">
                  <a class="page-link" aria-label="Next" @click="paging('n')">
                    <i class="bi bi-chevron-bar-right"></i>
                  </a>
                </li>
              </ul>
            </nav>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import moment from 'moment';
import axios from 'axios';

export default {
  data() {
    return {
      param: '',
      nCode: '',
      noticeList: [],             // 전체 목록
      pagedNoticeList: [],        // 현재 페이지에 보여줄 목록
      openedIndex: null,          // pagedNoticeList의 인덱스
      pageSize: 12,
      page: 1,
      cntPage: 1,
      cntNoticeList: 0,
      pastFlag: 'Y',

      renderedHtml: "",          // 공지사항 마크다운파일내용
    };
  },
  created() {
    this.param = this.$route.query.param;
    this.nCode = this.$route.query.nCode;
    this.getNoticeList();
  },
  methods: {
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    showArea(j) {
      this.openedIndex = this.openedIndex === j ? null : j;
      if (this.openedIndex !== null) 
      {
        this.getNoticeContent();
      }
    },

    // 공지내용 불러오기
    async getNoticeContent() {
      let filename = `${this.pagedNoticeList[this.openedIndex].noticeCode}.md`;
      let ctCd = filename.substring(0, 2);
      try 
      {
        let response = await axios.get(`/uploads/notice/${ctCd}/${filename}`);
        if (response.data.success) 
        {
          const content = response.data.content;
          // 마크다운문서변환
          // let md = new MarkdownIt();
          // this.renderedHtml = md.render(content);
          this.renderedHtml = content;
          // document.querySelectorAll('.markdown-body img, .ql-editor img').forEach(img => {
          //   img.removeAttribute('style');
          // });
        } 
        else 
        {
          throw new Error('Failed to load document');
        }
      } 
      catch (error) 
      {
        this.renderedHtml = "";  // 표시 영역 비움
        this.$swal.fire('', '공지상세내용이 없습니다', 'warning');
      }
    },


    // nCode로 공지오픈
    showNoticeByCode(nCode) {
      // pagedNoticeList에서 noticeCode로 인덱스 찾기
      const idx = this.pagedNoticeList.findIndex(n => String(n.noticeCode) === String(nCode));
      if (idx !== -1) 
      {
        this.openedIndex = idx;
        this.getNoticeContent();          //공지상세 호출
      } 
    },

    async getNoticeList() {
      let noticeList_tmp = await this.$api("/api/noticeList_new_new", {});
      if (this.param === "E") 
      {
        this.noticeList = noticeList_tmp.filter(item => item.ctCd === 'EV');
      } 
      else 
      {
        this.noticeList = noticeList_tmp;
      }

      // 페이지네이션 계산
      this.cntNoticeList = this.noticeList.length;
      this.cntPage = Math.ceil(this.cntNoticeList / this.pageSize);

      // 페이지별 데이터 추출
      this.setPagedNoticeList();

      // nCode가 있으면 해당 공지 자동 오픈
      if (this.nCode) {
        this.showNoticeByCode(this.nCode);
      }
    },

    setPagedNoticeList() {
      const offSet = (this.page - 1) * this.pageSize;
      this.pagedNoticeList = this.noticeList.slice(offSet, offSet + this.pageSize);
      // 페이지가 바뀔 때마다 열린 항목 닫기
      this.openedIndex = null;
    },

    paging(val) {
      if (val === undefined) 
      {
        this.page = 1;
      } 
      else if (val === "p") 
      {
        this.page--;
        if (this.page < 1) 
        {
          this.page = 1;
          this.$swal && this.$swal.fire('', '시작페이지입니다', 'info');
        }
      } 
      else if (val === "n") 
      {
        this.page++;
        if (this.page > this.cntPage) {
          this.page = this.cntPage;
          this.$swal && this.$swal.fire('', '마지막페이지입니다', 'info');
        }
      } 
      else 
      {
        this.page = val;
      }

      this.setPagedNoticeList();
      if (this.pagedNoticeList.length < 1) 
      {
        this.$swal && this.$swal.fire('', '데이타가 없습니다', 'info');
        return false;
      }
    },

    // getCurrencyFormat(value) {
    //   return value.toLocaleString();
    // },
    // getDateFormat(date) {
    //   return moment(date).format('YYYY-MM-DD');
    // },

  }
};
</script>

<style scoped>
#cnotice{
  margin:4rem 0 8rem;
}
@media (max-width:992px){
  #cnotice{
    margin:0rem 0 4rem;
  }
}

#cnotice h3{
  color:#333;
  font-weight: 600;
  font-size: 1.8rem;
  margin-bottom:1.5rem;
  text-transform: uppercase;
  text-align: center;
}

/**
  디바이스에 따라 등록일 표시위치를 가변한다
*/
.nCategoryTop.desktop-only  { display: table-cell; }
.nCategory.desktop-only     { display: table-cell; }
.nCategory-mobile           { display: none; }

.nRegDate.desktop-only      { display: table-cell; }
.nTitleRow .nRegDate-mobile { display: none; }

/*--------------------------------------------------------------
# 내용
--------------------------------------------------------------*/
#cnotice .no-cont{
  margin:3rem 0
}
#cnotice .no-cont .table{
  border-color:#e0e0e0; 
  border-top:2px solid #000;
  text-align: center;
}
#cnotice .no-cont thead th{
  font-size:1rem;
  font-weight:600;
  padding:15px 0;
  background-color: #f8f8f8;
}
#cnotice .no-cont tbody th{
  font-weight: normal;
  padding:10px 0
}

#cnotice pre {
  white-space:pre-wrap;
}

#cnotice .nContent {
  width: 100%;
}

#cnotice .notice{
  font-size:.8rem;
  color:#b20401;
  border:1px solid #b20401;
  padding:2px 9px;
  margin:0 30px 0 50px
}
#cnotice .event{
  font-size:.8rem;
  color:#080ba6;
  border:1px solid #080ba6;
  padding:2px 5px;
  margin:0 30px 0 50px
}
#cnotice .term{
  font-size:.75rem;
  text-align: center;
}

#cnotice .nContent .gopro{
  float: none; 
  margin:3rem auto 4rem
}
#cnotice .nContent .gopro a{
  color:#fff;
  background-color: #333;
  padding:15px 0;
  font-weight: 600;
  letter-spacing: 2px;
}
#cnotice .nContent .gopro a:hover{
  background-color: #000
}

.nRegDate
  {
    font-size: 0.9rem;
    color: #555;
    vertical-align: top;
  }

/*--------------------------------------------------------------
# 버튼
--------------------------------------------------------------*/
#cnotice .page{
  margin-top:3rem
}
#cnotice .page ul li{
  display: inline-block;
  list-style: none;
  padding:0 10px
}
#cnotice .page ul li:hover a{
  color:#777
}
#cnotice .page ul .now{
  background-color: #000;
  border-radius: 50%;
  padding:3px 11px 4px
}
#cnotice .page ul .now a{
  color:#fff;
}
#cnotice .page ul .now:hover a{
  color:#fff
}

/*--------------------------------------------------------------
  # 모바일화면 공지사항
--------------------------------------------------------------*/
/*--------------------------------------------------------------
  # 모바일화면 공지사항
--------------------------------------------------------------*/
@media (max-width: 768px) {
  .nCategoryTop.desktop-only { display: none; }
  .nCategory.desktop-only    { display: none; }
  .nRegDate.desktop-only     { display: none; }
  .nTitleTop                 { width: 90%; }
  .nContent                  { width: 100%; padding: 0; overflow-x: hidden; }
  .containerContent          { width: 100%; height: auto; overflow-x: hidden; }

  /* ✅ 핵심 수정: table 고정 레이아웃 */
  #cnotice .no-cont .table {
    table-layout: fixed !important;
    width: 100% !important;
  }

  /* ✅ td 넘침 차단 (table-layout:fixed 있어야 작동) */
  #cnotice .no-cont tbody td {
    overflow: hidden;
    word-break: break-word;
  }

  .nTitleRow {
    display: flex;
    justify-content: space-between;
    gap: .2rem;
  }
  .nTitleRow .nCategory-mobile {
    display: inline-block;
    font-size: 0.8rem;
    color: #333;
    width: 18%;
    vertical-align: middle;
  }
  .nTitleRow .nContentTitle {
    display: inline-block;
    font-size: 0.8rem;
    width: 76%;
    color: #333;
    vertical-align: middle;
  }  
  .nTitleRow .nRegDate-mobile { 
    display: inline-block;
    font-size: 0.6rem;
    color: #555;
    white-space: nowrap;
    vertical-align: middle;
    text-align: center;
    width:11%;
  }

  /* ✅ v-html 내부 이미지 반응형 */
  ::v-deep .ql-editor img,
  ::v-deep .markdown-body img {
    max-width: 100% !important;
    width: auto !important;
    height: auto !important;
  }

  ::v-deep .ql-editor,
  ::v-deep .markdown-body {
    overflow-x: hidden;
    word-break: break-word;
  }
}
</style>
